import {Setting} from "./Setting";

export const geographySetting: Setting = {
    key: "Geography",
    title: "География",
    description: `География определяет физическую структуру мира, создаёт уникальные локации, влияющие на атмосферу, сюжет и геймплей. Она задаёт тон окружающей среды, влияет на культуру, климат и ресурсы мира. `,
    components: [
        {
            title: "Континенты и регионы",
            subComponents: [
                {
                    title: "Континенты",
                    description: `Один или несколько крупных массивов суши. Уникальные ландшафты, культуры и климаты.`,
                    examples: ["Континент Вестерос, разделённый на Семь Королевств."]
                },
                {
                    title: "Регионы",
                    description: `Горы, леса, пустыни, равнины. Разделение на королевства, племенные земли, дикие зоны.`,
                    examples: ["Ледяные земли на севере, где обитают дикие существа."]
                }]
        },
        {
            title: "Водные пространства",
            subComponents: [
                {
                    title: "Моря и океаны",
                    description: `Огромные пространства, разделяющие континенты. Подводные города, пиратские острова.`,
                    examples: ["Море Черепа, где обитают морские чудовища."]
                },
                {
                    title: "Реки и озёра",
                    description: `Основные источники воды, способствующие развитию городов. Мифические реки (например, река душ или магии).`,
                    examples: ["Река Времени, меняющая ход событий."]
                },
                {
                    title: "Болота",
                    description: `Туманные, труднопроходимые территории с аномалиями.`,
                    examples: ["Болото Печали, где обитают духи умерших."]
                }]
        },
        {
            title: "Горные цепи и возвышенности",
            subComponents: [
                {
                    title: "Горы",
                    description: `Дом для горных народов, драконов или храмов. Природные барьеры, определяющие границы.`,
                    examples: ["Горы Вечной Скорби, где обитают гиганты."]
                },
                {
                    title: "Плато",
                    description: `Высокогорные степи, подходящие для пастбищ или городов.`,
                    examples: ["Плато Ветров, где обитают кочевники."]
                },
                {
                    title: "Вулканы",
                    description: `Активные и потухшие вулканы с магическими или ресурсными свойствами.`,
                    examples: ["Вулкан Жизни, источник вечной молодости."]
                }]
        },
        {
            title: "Леса и джунгли",
            subComponents: [
                {
                    title: "Леса",
                    description: `Дремучие, магические, светлые. Места обитания мифических существ.`,
                    examples: ["Лес Тени, где обитают вампиры."]
                },
                {
                    title: "Джунгли",
                    description: `Экзотическая флора и фауна, скрытые древние руины.`,
                    examples: ["Джунгли Живых, где обитают дикие звери."]
                },
                {
                    title: "Проклятые рощи",
                    description: `Леса, где обитают духи, проклятия или аномалии.`,
                    examples: ["Роща Ведьм, где обитают проклятые души."]
                }]
        },
        {
            title: "Пустыни и степи",
            subComponents: [
                {
                    title: "Пустыни",
                    description: `Жаркие песчаные или ледяные пространства. Оазисы, караванные пути.`,
                    examples: ["Пустыня Смерти, где обитают драконы."]
                },
                {
                    title: "Степи",
                    description: `Бескрайние равнины, населённые кочевниками или дикими животными.`,
                    examples: ["Степи Ветров, где обитают дикие кони."]
                }]
        },
        {
            title: "Особые локации",
            subComponents: [
                {
                    title: "Руины и заброшенные города",
                    description: `Остатки древних цивилизаций.`,
                    examples: ["Забытый город, где спрятаны древние артефакты."]
                },
                {
                    title: "Магические зоны",
                    description: `Локации с изменённой реальностью.`,
                    examples: ["Зона Хаоса, где законы физики не действуют."]
                },
                {
                    title: "Переходные территории",
                    description: `Лимб, порталы между мирами, скрытые долины.`,
                    examples: ["Долина Теней, где время искажено."]
                }]
        },
        {
            title: "Климатические зоны",
            subComponents: [
                {
                    title: "Арктические",
                    description: `Суровые снежные пустыни и ледяные горы.`,
                    examples: ["Ледяные пустоши, где обитают ледяные великаны."]
                },
                {
                    title: "Тропические",
                    description: `Жаркий, влажный климат с экзотическими лесами.`,
                    examples: ["Джунгли Жары, где обитают ядовитые змеи."]
                },
                {
                    title: "Умеренные",
                    description: `Четыре сезона, подходящие для жизни.`,
                    examples: ["Леса Весны, где обитают лесные эльфы."]
                },
                {
                    title: "Пустынные",
                    description: `Засушливые земли с редкими дождями.`,
                    examples: ["Пустыня Пыли, где обитают песчаные черви."]
                }]
        }
    ],
    prompt: {
        component: {
            list: "Перечисли возможные объекты географии и опиши их, включая местоположение",
            single: "Сгенерируй объект географии для мира. Опиши его расположение, внешний вид и влияние на мир",
            extend: "Дополни описание объекта географии и разбей на абзацы. Его расположение, внешнее описание, как он влияет на мир, персонажей и на события."
        },
        element: {
            list: "Перечисли возможные элементы географии и опиши их",
            single: "Сгенерируй элемент географии для мира. Опиши его внешний вид и влияние на мир",
            extend: "Дополни описание элемента географии и разбей на абзацы. Его внешнее описание, как он влияет на мир, персонажей и на события."
        },
        lore: {
            list: "Создай элементы лора на основе этого элемента географии. Его историю, мифы, влияние на мир и персонажей",
            single: "Создай элементы лора на основе этого элемента экономики. Опиши что-то одно, например: историю, мифы, влияние на мир и персонажей",
            extend: "Дополни описание элемента лора географии и разбей на абзацы."
        }
    }
}